import { render, staticRenderFns } from "./projectListElement.vue?vue&type=template&id=1b655662&scoped=true"
import script from "./projectListElement.vue?vue&type=script&lang=js"
export * from "./projectListElement.vue?vue&type=script&lang=js"
import style0 from "./projectListElement.vue?vue&type=style&index=0&id=1b655662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b655662",
  null
  
)

export default component.exports